/** @format */

import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import { TListType } from '../declarations';
import { selectorRoomListType } from '../selectors';

export const useGTMListType = () => {
  const dispatch = useAppDispatch();
  const roomListType = useAppSelector(selectorRoomListType);

  const onChangeGTMListType = (payload: TListType) => {
    dispatch({
      type: 'SET_ROOM_LIST_TYPE',
      payload,
    });
  };

  return { onChangeGTMListType, roomListType };
};
